// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fgOu","colMin":"styles_colMin__1qy0L"};